import { Injectable } from "@angular/core";
import { PublicHttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class PublicValidationProcessService {
  constructor(private publicHttp: PublicHttpClientService) {}

  public getEventsLog(id: string | number): Observable<any> {
    return this.publicHttp
      .get("/api/public/validation_processes/" + id + "/events_log")
      .pipe(tap((_) => console.log("ValidationProcessService.getEventsLog: Ok.")));
  }

  public getCurrentStep(id: string): Observable<any> {
    return this.publicHttp
      .get("/api/public/validation_processes/" + id + "/current_step")
      .pipe(tap((_) => console.log("PublicValidationProcessService.getCurrentStep: Ok.")));
  }

  public postRemindEvent(id: string, metadata): Observable<any> {
    const params = {
      ...metadata,
    };
    return this.publicHttp
      .post("/api/public/validation_processes/" + id + "/remind_event", params)
      .pipe(tap((_) => console.log("PublicValidationProcessService.postRemindEvent: Ok.")));
  }

  public postVeridoc(params, id): Observable<any> {
    return this.publicHttp
      .post("/api/public/validation_processes/" + id + "/veridoc", params)
      .pipe(tap((_) => console.log("ValidationProcessService.postVeridoc: Ok.")));
  }

  public postValidationProcessEvent(id, event, metadata = {}): Observable<any> {
    const params = {
      metadata: metadata,
    };
    return this.publicHttp
      .post("/api/public/validation_processes/" + id + "/event?event_name=" + event, params)
      .pipe(tap((_) => console.log("ValidationProcessService.postValidationProcessEvent: Ok.")));
  }

  public getApplicationByProcessValidationId(id): Observable<any> {
    return this.publicHttp
      .get("/api/public/validation_processes/" + id, {})
      .pipe(tap((_) => console.log("ValidationProcessService.getApplicationByProcessValidationId: Ok.")));
  }

  public createReferences(id, references): Observable<any> {
    return this.publicHttp
      .post("/api/public/validation_processes/" + id + "/references", references)
      .pipe(tap((_) => console.log("ValidationProcessService.createReferences: Ok.")));
  }
}
